//#region types
import { IconDefinitionConstants } from "utils/constants";
import { DialogProps } from "models/propTypes/dialogPropTypes";
import { DialogEnums } from "models/enums";
import { TranslationKeys } from "translations";
//#endregion
//#region components
import AddExtraSalaryFormContainer from "./addExtraSalaryFormContainer";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

function useAddExtraSalaryDialog(): DialogProps {
  return {
    isOpen: false,
    title: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Salary.AddExtraSalaryTitle),
    titleIcon: IconDefinitionConstants.WIncome2,
    actions: [
      {
        text: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Save),
        successMessage: TranslationKeys.Document.CreateSuccess,
      },
    ],
    dialogType: DialogEnums.DialogType.Content,
    children: <AddExtraSalaryFormContainer />,
    maxWidth: "sm",
  };
}

export default useAddExtraSalaryDialog;
